import React, { useState, useRef, useEffect } from 'react';
import { Globe, ChevronDown } from 'lucide-react';
import ReactCountryFlag from 'react-country-flag';

const LanguageSelector = ({ currentLanguage, onLanguageChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'ko', name: '한국어', nativeName: '한국어', countryCode: 'KR' },
    { code: 'en', name: 'English', nativeName: 'English', countryCode: 'US' },
    { code: 'fr', name: 'Français', nativeName: 'Français', countryCode: 'FR' },
    { code: 'ja', name: '日本語', nativeName: '日本語', countryCode: 'JP' }
  ];

  const currentLanguageData = languages.find(lang => lang.code === currentLanguage);

  // 드롭다운 외부 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageSelect = (languageCode) => {
    onLanguageChange(languageCode);
    setIsOpen(false);
  };

  return (
    <div className="flex items-center space-x-2">
      <Globe size={16} className="text-gray-600" />
      
      {/* 커스텀 드롭다운 */}
      <div className="relative" ref={dropdownRef}>
        {/* 드롭다운 트리거 버튼 */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center space-x-2 bg-white border border-gray-300 text-gray-700 text-sm rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200 hover:bg-gray-50"
        >
          <ReactCountryFlag
            countryCode={currentLanguageData?.countryCode || 'KR'}
            svg
            style={{
              width: '16px',
              height: '12px',
              borderRadius: '2px'
            }}
          />
          <span>{currentLanguageData?.nativeName || '한국어'}</span>
          <ChevronDown 
            size={14} 
            className={`text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
          />
        </button>

        {/* 드롭다운 메뉴 */}
        {isOpen && (
          <div className="absolute top-full left-0 mt-1 w-full bg-white border border-gray-300 rounded shadow-lg z-50">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageSelect(lang.code)}
                className={`w-full flex items-center space-x-3 px-3 py-2 text-sm text-left hover:bg-blue-50 transition-colors duration-200 ${
                  currentLanguage === lang.code ? 'bg-blue-50' : ''
                }`}
              >
                <ReactCountryFlag
                  countryCode={lang.countryCode}
                  svg
                  style={{
                    width: '16px',
                    height: '12px',
                    borderRadius: '2px'
                  }}
                />
                <span className="text-gray-700">{lang.nativeName}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;
